import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpCenterComponent } from './help-center.component';
import { HelpCenterDialogModule } from 'src/app/components/help-center-dialog/help-center-dialog.module';

@NgModule({
  declarations: [
    HelpCenterComponent
  ],
  imports: [
    CommonModule,
    HelpCenterDialogModule
  ],
  exports: [
    HelpCenterComponent
  ]
})
export class HelpCenterModule { }
